import { request } from './service'

// ========== 分类 ==========
export function listCategories() {
  return request({ url: 'bbs/category/', method: 'get' })
}

// ========== 标签 ==========
export function listTags() {
  return request({ url: 'bbs/tag/', method: 'get' })
}

// ========== 帖子 ==========
export function listPosts(params = {}) {
  return request({ url: 'bbs/post/', method: 'get', params })
}

/** 发帖数排行榜（默认前 10） */
export function getTopAuthors(params = {}) {
  return request({ url: 'bbs/post/top-authors/', method: 'get', params })
}

export function getPost(id) {
  return request({ url: `bbs/post/${id}/`, method: 'get' })
}

export function createPost(data) {
  return request({ url: 'bbs/post/', method: 'post', data })
}

export function updatePost(id, data) {
  return request({ url: `bbs/post/${id}/`, method: 'put', data })
}

export function deletePost(id) {
  return request({ url: `bbs/post/${id}/`, method: 'delete' })
}

export function reactToPost(id, reactionType) {
  return request({
    url: `bbs/post/${id}/react/`,
    method: 'post',
    data: { reaction_type: reactionType }
  })
}

// ========== 评论 ==========
export function listComments(postId, params = {}) {
  return request({
    url: 'bbs/comment/',
    method: 'get',
    params: { post: postId, ...params }
  })
}

export function createComment(data) {
  return request({ url: 'bbs/comment/', method: 'post', data })
}

export function deleteComment(id) {
  return request({ url: `bbs/comment/${id}/`, method: 'delete' })
}

export function reactToComment(id) {
  return request({
    url: `bbs/comment/${id}/react/`,
    method: 'post',
    data: { reaction_type: 1 }
  })
}

// ========== 投票 ==========
export function votePost(postId, optionId) {
  return request({
    url: `bbs/post/${postId}/vote/`,
    method: 'post',
    data: Array.isArray(optionId) ? { option_ids: optionId } : { option_id: optionId }
  })
}
